import React, { useState } from 'react';

import useTrackEvent from '@hooks/useEventTracking';
import { Page } from '@tracking';
import { OfferOption } from '@utils/backend-api/subscribe';

import Checkout from '../SubscribeTest/Checkout';
import OfferSelection from '../SubscribeTest/OfferSelection';

interface ContentProps {
  offers: OfferOption[];
}

enum GiftLandingForLeadPage {
  OfferSelection = 1,
  Checkout = 2,
}

const Context = ({ offers }: ContentProps) => {
  const { Track } = useTrackEvent({ page: Page.GiftLandingForLead });
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [currentPage, setCurrentPage] = useState(GiftLandingForLeadPage.OfferSelection);

  return (
    <Track>
      {currentPage === GiftLandingForLeadPage.OfferSelection && (
        <OfferSelection
          offers={offers}
          onOfferClick={() => setCurrentPage(GiftLandingForLeadPage.Checkout)}
          setSelectedOffer={setSelectedOffer}
          isGiftLanding
        />
      )}
      {currentPage === GiftLandingForLeadPage.Checkout && (
        <Checkout
          onBackClick={() => setCurrentPage(GiftLandingForLeadPage.OfferSelection)}
          selectedOffer={selectedOffer}
          presentedOfferCodes={offers.map((offer) => offer.code)}
          showGiftRecipientForm
        />
      )}
    </Track>
  );
};

export default Context;
